<!-- Trust Name Input Form -->
<div class="trust-search">
  <form @submit.prevent="submit_trust_name">
    <div class="form-group">
      <label for="trust_name" class="fw-bold text-xs">Trust Name</label>
      <input
        type="text"
        v-model="form.trust_name"
        class="form-control text-xs rounded-small p-3 shadow-sm"
        id="trust_name"
        required
      />
    </div>
    <div class="d-flex justify-content-end my-2">
      <button type="submit" class="btn btn-primary-color rounded-pill text-xs">
        Search
      </button>
    </div>
  </form>
</div>

<!-- Trust Results Modal -->
<div
  class="d-flex justify-content-center align-items-center min-vh-50"
  v-if="trust_results"
>
  <div class="col-11 col-sm-10 col-md-10 col-lg-8 col-xl-8 p-3">
    <p class="text-xs text-center">
      Please select a trust from the search results below or add a new trust
      using the form provided.
    </p>
    <hr class="fw-light" />

    <!-- Navigation Tabs -->
    <div class="d-flex justify-content-center">
      <ul class="nav nav-tabs mb-2" id="trustTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active text-dark text-xs"
            id="trust-results-tab"
            data-bs-toggle="tab"
            data-bs-target="#trust-results"
            type="button"
            role="tab"
            aria-controls="trust-results"
            aria-selected="true"
          >
            Search Results
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link text-dark text-xs"
            id="add-new-trust-tab"
            data-bs-toggle="tab"
            data-bs-target="#add-new-trust"
            type="button"
            role="tab"
            aria-controls="add-new-trust"
            aria-selected="false"
          >
            Add New Trust
          </button>
        </li>
      </ul>
    </div>

    <!-- Tab Content -->
    <div class="tab-content" id="trustTabContent">
      <!-- Trust Results Tab -->
      <div
        class="tab-pane fade show active"
        id="trust-results"
        role="tabpanel"
        aria-labelledby="trust-results-tab"
      >
        <div class="row" v-if="trust_results && trust_results.length > 0">
          <div
            class="col-sm-6 col-lg-4 p-2"
            v-for="(trust, index) in trust_results"
            :key="index"
          >
            <div class="card shadow rounded-3 h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 mb-2">
                    <label class="d-flex align-items-center">
                      <i class="fas fa-building text-primary"></i>
                      <span class="fw-bold text-xs px-2">Trust Name</span>
                    </label>
                    <p class="text-xs mb-0">{{ trust.TrustName }}</p>
                  </div>

                  <div class="col-12 mb-2">
                    <label class="d-flex align-items-center">
                      <i class="fas fa-map-marker-alt text-success"></i>
                      <span class="fw-bold text-xs px-2">Masters Office</span>
                    </label>
                    <p class="text-xs mb-0">{{ trust.MastersOffice }}</p>
                  </div>
                </div>
              </div>

              <div
                class="card-footer d-flex justify-content-center bg-white border-0 rounded-3"
              >
                <button
                  type="button"
                  class="btn btn-bg-green rounded-small text-xs"
                  @click="save_trust_selection(trust.TrustID)"
                  :disabled="loading"
                >
                  Select Trust
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- No Results Found -->
        <div v-else>
          <div class="card shadow rounded-3 border-light">
            <div class="card-body text-center">
              <p
                class="d-flex justify-content-center align-items-center flex-column"
              >
                <i
                  class="fas fa-exclamation-triangle text-warning text-md p-2"
                ></i>
                <span class="text-xs text-muted p-2">
                  No trusts found matching your search criteria.
                </span>
                <span class="text-xs text-muted">
                  Please try a different search term or add a new trust using
                  the form above.
                </span>
              </p>

              <!-- New Search Button -->
              <button
                type="button"
                class="btn btn-outline-primary btn-sm rounded-small text-xs mt-2"
                @click="reset_search"
              >
                New Search
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Add New Trust Tab -->
      <div
        class="tab-pane fade"
        id="add-new-trust"
        role="tabpanel"
        aria-labelledby="add-new-trust-tab"
      >
        <div>
          <form @submit.prevent="add_new_trust">
            <div class="mb-3">
              <label class="text-xs fw-bold">Trust Name</label>
              <input
                type="text"
                class="form-control text-xs"
                v-model="new_trust.trust_name"
                required
              />
            </div>
            <div class="mb-3">
              <label class="text-xs fw-bold">File Number</label>
              <input
                type="text"
                class="form-control text-xs"
                v-model="new_trust.file_number"
                placeholder="e.g., IT000000/2016(T)"
                required
              />
            </div>
            <div class="mb-3">
              <label class="text-xs fw-bold">Masters Office</label>
              <select
                class="form-control text-xs"
                v-model="new_trust.masters_office"
                required
              >
                <option value="" hidden>Select Masters Office</option>
                <option
                  v-for="office in masters_offices"
                  :key="office"
                  :value="office"
                >
                  {{ office }}
                </option>
              </select>
            </div>
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-bg-green rounded-small text-xs"
                :disabled="loading"
              >
                Add Trust
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
